import { render, staticRenderFns } from "./MidiaArticles.vue?vue&type=template&id=2271e0b8"
import script from "./MidiaArticles.vue?vue&type=script&lang=js"
export * from "./MidiaArticles.vue?vue&type=script&lang=js"
import style0 from "./MidiaArticles.vue?vue&type=style&index=0&id=2271e0b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports